<template>
  <div class="menu">
    <Loading :loading="MENU_LOADING" :minimized="minimized">
      <template #default>
        <span v-click-outside="handleCloseMinimizedMenu">
          <div
            v-for="(item, index) in itemsFiltered"
            :key="index"
            @click="goTo(item.routeName)"
          >
            <div
              class="menu__item"
              :class="{
                'menu__item--active': isActiveMenu(item),
                ' menu__item--minimized': minimized,
              }"
              v-b-toggle="`children-${index}`"
              @mousedown="showMinimizedMenu = index"
            >
              <slide-x-right-transition>
                <div
                  v-if="minimized && showMinimizedMenu === index"
                  class="menu__item__children__cover"
                >
                  <div class="menu__item__children__cover__children-box">
                    <div
                      class="menu__item__children__cover__children-box__title"
                    >
                      {{ item.name }}
                    </div>
                    <div
                      class="menu__item__children__cover__children-box__items"
                      v-if="item.children.length"
                    >
                      <router-link
                        v-for="(child, index) in item.children"
                        :key="index"
                        class="menu__item__children__cover__children-box__items__item"
                        :class="{
                          'menu__item__children__cover__children-box__items__item--active':
                            child.active,
                        }"
                        :to="generateRouteLink(child.routeName)"
                      >
                        <div
                          class="menu__item__children__cover__children-box__items__item__title"
                          :class="{
                            'menu__item__children__cover__children-box__items__item--active':
                              child.active,
                          }"
                        >
                          {{ child.name }}
                        </div>
                      </router-link>
                      <!-- <div
                        v-for="(child, index) in item.children"
                        :key="index"
                        class="menu__item__children__cover__children-box__items__item"
                        :class="{
                          'menu__item__children__cover__children-box__items__item--active':
                            child.active,
                        }"
                        @click="goTo(child.routeName)"
                      >
                        <div
                          class="menu__item__children__cover__children-box__items__item__title"
                        >
                          {{ child.name }}
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </slide-x-right-transition>
              <div class="menu__item__right-box">
                <div class="menu__item__right-box__icon-box">
                  <mdicon
                    v-if="startsWith('mdi', item.icon)"
                    :name="item.icon.slice(4)"
                    size="24"
                  />
                  <i v-else class="font-size-16" :class="item.icon" />
                  <span
                    v-if="item.badge && minimized"
                    class="menu__item__right-box__icon-box__badge"
                  >
                    {{ item.badge }}
                  </span>
                </div>
                <div v-show="!minimized" class="menu__item__right-box__title">
                  {{ item.name }}
                </div>
              </div>
              <div class="menu__item__left-box">
                <div
                  v-if="item.badge && !minimized"
                  class="menu__item__left-box__badge"
                >
                  {{ item.badge }}
                </div>
                <mdicon
                  v-if="item.children.length && !minimized"
                  name="chevron-down"
                  size="24"
                />
              </div>
            </div>

            <b-collapse
              accordion="children-accordion"
              :id="`children-${index}`"
              :visible="isActiveMenu(item)"
              v-if="!minimized && item.children.length"
            >
              <div class="menu__children">
                <router-link
                  v-for="(child, index) in item.children"
                  :key="index"
                  class="menu__children__item text-decoration-none"
                  :class="{ 'menu__children__item--active': child.active }"
                  :to="generateRouteLink(child.routeName)"
                >
                  <div
                    class="menu__item__children__cover__children-box__items__item__title"
                    :class="{
                      'menu__item__children__cover__children-box__items__item--active':
                        child.active,
                    }"
                  >
                    {{ child.name }}
                  </div>
                </router-link>
                <!-- <div
                  v-for="(child, index) in item.children"
                  :key="index"
                  class="menu__children__item"
                  :class="{ 'menu__children__item--active': child.active }"
                  @click="goTo(child.routeName)"
                >
                  <div class="menu__children__item__title">
                    {{ child.name }}
                  </div>
                </div> -->
              </div>
            </b-collapse>
          </div>
        </span>
      </template>
    </Loading>
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import { mapGetters } from "vuex";
import { pathOr, startsWith } from "ramda";
import { goToRoute, storeDispatcher } from "@/shared/utils";

export default {
  inject: ["MENU_LOADING"],
  components: { Loading },
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMinimizedMenu: null,
      staticItems: [
        {
          icon: "mdi-home-variant-outline",
          name: "خانه",
          route_name: "dashboard",
          active: false,
          children: [],
          show: false,
        },
        {
          icon: "mdi-bell-outline",
          name: "اعلانات",
          route_name: "/",
          active: false,
          children: [],
          badge: 2,
          show: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["menuItems"]),
    itemsFiltered() {
      const items = this.menuItems.map((item) => {
        const children = pathOr([], ["children"], item).map((child) => {
          return {
            name: child.name,
            routeName: child.route_name,
            active: this.checkActiveMenu(child),
            children: [],
          };
        });
        return {
          icon: item.icon,
          name: item.name,
          routeName: item.route_name,
          active: this.checkActiveMenu(item),
          children,
        };
      });
      return [...this.staticItems, ...items].filter((item) =>
        pathOr(true, ["show"], item)
      );
    },
  },
  methods: {
    pathOr,
    startsWith,
    storeDispatcher,
    checkActiveMenu(item) {
      const routeName = pathOr(null, ["route_name"], item);
      return this.$route.matched.some((route) => route.name === routeName);
    },
    isActiveMenu(item) {
      if (!item.children.length) {
        return item.active;
      }

      if (item.children.length) {
        return item.children.some((child) => child.active);
      }

      return false;
    },
    handleCloseMinimizedMenu() {
      this.showMinimizedMenu = null;
    },
    async goTo(routeName) {
      const target = routeName === "profile_info" ? "profile" : routeName;
      const isCurrentRoute = this.$route.name === target;
      if (!target || isCurrentRoute) return;
      goToRoute(target, {}, {}, false);
      await storeDispatcher("mobileHeaderTitleCount", null);
      await storeDispatcher("visibleSidebarMobile", false);
    },

    generateRouteLink(routeName) {
      const target = routeName === "profile_info" ? "profile" : routeName;
      const routeData = this.$router.resolve({ name: target });
      const link = pathOr(null, ["route", "fullPath"], routeData);
      return link;
    },
  },
};
</script>
